import { useState } from "react";
import { Code2, ChevronDown, ChevronRight } from "lucide-react";
import { Card } from "../_shared";

export default function RawJsonCard({ raw }) {
  const [open, setOpen] = useState(false);
  return (
    <Card className="lg:col-span-3" testid="admin-assessment-raw">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-3 text-left hover:bg-slate-50"
        data-testid="admin-assessment-raw-toggle"
      >
        <span className="inline-flex items-center gap-2 text-sm font-medium text-slate-900">
          <Code2 className="h-4 w-4 text-slate-400" />
          Raw assessment document
        </span>
        {open ? (
          <ChevronDown className="h-4 w-4 text-slate-400" />
        ) : (
          <ChevronRight className="h-4 w-4 text-slate-400" />
        )}
      </button>
      {open && (
        <pre
          className="px-5 pb-5 text-[11px] leading-relaxed text-slate-700 bg-slate-50 overflow-x-auto whitespace-pre-wrap break-words"
          data-testid="admin-assessment-raw-json"
        >
          {JSON.stringify(raw, null, 2)}
        </pre>
      )}
    </Card>
  );
}
